import { initializeApp } from "firebase/app";
import { Analytics, getAnalytics, isSupported } from "firebase/analytics";
import { getFirestore, initializeFirestore } from "firebase/firestore";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import logger from '../utils/logger';

const firebaseConfig = {
  apiKey: "AIzaSyC6aZK_lspAfPYyplaPpry5tY1umLr60kI",
  authDomain: "iptv-player-3f4dc.firebaseapp.com",
  projectId: "iptv-player-3f4dc",
  storageBucket: "iptv-player-3f4dc.firebasestorage.app",
  messagingSenderId: "456388812034",
  appId: "1:456388812034:web:c49197815e25bad564361b",
  measurementId: "G-6TV2NBCWGV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth
const auth = getAuth(app);

// Initialize Firestore with settings to avoid errors
const db = initializeFirestore(app, {
  experimentalForceLongPolling: true
});

// Helper function to determine if analytics should be enabled
const shouldEnableAnalytics = (): boolean => {
  // Check if we're in development mode
  const isDevelopment = process.env.NODE_ENV === 'development';
  
  // Check if we're on localhost
  const isLocalhost = 
    window.location.hostname === 'localhost' || 
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.includes('192.168.');
  
  // Only enable analytics in production environments and non-localhost domains
  return !isDevelopment && !isLocalhost;
};

// Initialize Analytics conditionally
let analytics: Analytics | null = null;
isSupported().then(supported => {
  if (supported) {
    // Only enable analytics if not in development/localhost
    if (shouldEnableAnalytics()) {
      analytics = getAnalytics(app);
      logger.debug('Firebase Analytics initialized');
    } else {
      logger.debug('Firebase Analytics disabled in development/localhost');
    }
  }
}).catch(err => {
  logger.warn('Firebase Analytics not supported:', err);
});

export { db, analytics, auth }; 